import {FlowchartFeatures} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/FlowchartFeaturesContext';
import {DefaultProcessFlowchartNodeAdapter} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';

import {getAdapterForNodeData} from './adapterUtils';
import {getAllNodeDetailsSidepanelTabsForTaskNodeData} from './getAllNodeDetailsSidepanelTabsForTaskNode';
import {
  isStaticPlaceholderNodeData,
  isStaticRouterNodeData,
  isStaticTaskSchemaNodeData,
  StaticFlowchartNodeData,
} from './processFlowchartConfigEditorNodeTypes';

export default function doesNodeHaveRightSidepanelContent(
  nodeData: StaticFlowchartNodeData,
  flowchartFeatures?: FlowchartFeatures,
  allowTaskNodeSidepanelOnClick: boolean = true
): boolean {
  if (isStaticPlaceholderNodeData(nodeData)) {
    return true;
  }

  const adapter = getAdapterForNodeData(nodeData);
  if (adapter == null) {
    return false;
  }

  if (isStaticTaskSchemaNodeData(nodeData) && nodeData.isInaccessible) {
    return false;
  }

  if (isStaticTaskSchemaNodeData(nodeData) && allowTaskNodeSidepanelOnClick) {
    const tabs = getAllNodeDetailsSidepanelTabsForTaskNodeData(nodeData, flowchartFeatures);
    return tabs.length > 0;
  }

  if (adapter instanceof DefaultProcessFlowchartNodeAdapter) {
    return isStaticRouterNodeData(nodeData);
  }

  return false;
}
